import { render, staticRenderFns } from "./Safety.vue?vue&type=template&id=6e8df02e&scoped=true&"
import script from "./Safety.vue?vue&type=script&lang=ts&"
export * from "./Safety.vue?vue&type=script&lang=ts&"
import style0 from "./Safety.vue?vue&type=style&index=0&id=6e8df02e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8df02e",
  null
  
)

export default component.exports